package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("visit_places")
@Composable
fun KidsVisitPlacesPage() {
    BlogLayout(
        PageProperties(
            "Places I Like to Visit",
            "We are surrounded by many beautiful places that we can visit. Places that are built by humans are called man-made places. Places that are found in nature are called natural places."
        ),
        BlogProperties("Kids", "Places I Like to Visit")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Types of places",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Natural places: Hill stations, Beaches, Wildlife sanctuaries and national parks",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Man-made places: Red Fort, Delhi, Ellora Caves, Aurangabad, Charminar, Hyderabad",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(
                src = Resources.Images.VISIT_PLACES,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Visit Places"
            )

            SpanText(
                text = "Hill stations - (Shimla, Manali, Ooty)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A hill station is a town that is located high up on hills or mountains.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "At a hill station, we can enjoy activities like climbing, trekking or riding mini trains.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Shimla and Manali are among the most popular hill stations in India.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Beaches - (Goa)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A beach is an area of land that lies along a water body like an ocean or a sea.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Beaches are made up of sand and tiny pebbles. Rocks and seashells are usually found on beaches. On beaches, we may see animals like crabs, starfish and sea turtles.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We enjoy making sand castles and playing water sports like sailing and swimming.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Wildlife sanctuaries and national parks - (Jim Corbett National Park, Uttarakhand)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In sanctuaries and national parks wild animals live safely in their natural surroundings.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These places are guarded by forest officers. They help to protect animals from hunting and other human activities.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We can enjoy wildlife safaris in sanctuaries. National parks have nature trails and trekking.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Historical places - (fort, palace, cave, monument, pilgrimage)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Historical places such as ancient (very old) forts, palaces, battlefields, caves and monuments are found across India. These places tell us about our past. We learn about kings, queens and brave warriors from these places.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Fort",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A fort is a building built on higher ground with a wall or fence around it. Ancient forts were used by soldiers as a place to guard and protect their kingdoms from their enemies.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Place",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A palace is a large house in which a king and queen live. Palace are huge and have many large rooms. The rooms have high ceilings and expensive furniture.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Cave",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A cave is a natural hollow space with an opening",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A cave may be underground or on the side of a hill or mountain.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People used to live in caves a long time ago. Some of the carvings made by them on the cave walls tell us how they used to live in the past.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Monument",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A monument is a statue, building or other structure built to remember a famous person or event.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Places of pilgrimage",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A pilgrimage is a visit to a holy place where people go to offer special prayers. People of different faiths and religions live in our country and they have their own places of worship.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Farm",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A farm is a piece of land that is used to grow crops and raise animals. Food necessary for the survival of human beings is grown on farms.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Zoo",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A zoo is a place where many animals and birds live in an enclosed area. We can see the animals and birds from a distance so that we are safe. We get to learn about different birds and animals by visiting the zoo.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Museum",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A museum is a place where ancient and valuable things are collected and displayed. Objects like paintings, monuments and ancient coins are kept in museums. We can learn about art, history and science by observing the objects displayed in museums.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Amusement park",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An amusement park is a place with various attractions such as rides, games and other entertainment events.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We ride the ferris wheel, different types of food with our family and friends.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Mall",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A mall is a large building that has many stores and shops in it. In a mall, people enjoy activities like shopping, eating, watching movies or playing games.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Worksheet - 1",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Choose the correct word from the box and fill in the blank.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A ____________ is a statue, building or other structure built to remember a famous person. monument",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A _________ is a place where people enjoy water sports. beach",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A _________ is a place where many animals live in an enclosed area. zoo",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A __________ is a large house in which a king or queen lives. palace",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A _____________ is a town that is located high up on hills or mountains. hill station",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Write ‘T’ if the statement is true and write ‘F’ if the statement is false.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A museum is a natural place _________",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should take care of our belongings while visiting places _________. False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should not tease or harm wildlife _________. True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should litter the place _________. False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A mall is a place where we offer prayers _________. False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Answer the following questions.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a place of pilgrimage?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "A pilgrimage is a visit to a holy place where people go to offer special prayers.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.3.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name a place where rides, games and other entertainment events are held.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Amusement park",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.3.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a man-made place?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Places that are built by humans are called man-made places.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.3.em)
                        )
                    }
                }
            }
        }
    }
}